// src/components/lessons/renderers/UnorderedListRenderer.jsx
import React, { useState } from 'react';

const UnorderedListRenderer = ({ block, isMobile }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <ul style={{
      listStyle: 'none',
      padding: 0,
      margin: '1rem 0'
    }}>
      {block.items.map((item, i) => (
        <li
          key={i}
          style={{
            color: '#000000',
            lineHeight: '1.7',
            marginBottom: '0.75rem',
            fontSize: isMobile ? '0.95rem' : '1rem',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.75rem',
            padding: '0.5rem',
            marginLeft: '-0.5rem',
            marginRight: '-0.5rem',
            borderRadius: '0.5rem',
            background: hoveredIndex === i ? '#F9FAFB' : 'transparent',
            transition: 'all 0.2s ease',
            cursor: 'default',
            opacity: hoveredIndex === i ? 1 : 0.85
          }}
          onMouseEnter={() => setHoveredIndex(i)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <span style={{
            width: '6px',
            height: '6px',
            borderRadius: '50%',
            background: hoveredIndex === i ? '#000000' : '#3A86FF',
            marginTop: '0.5rem',
            flexShrink: 0,
            transition: 'all 0.2s ease',
            transform: hoveredIndex === i ? 'scale(1.3)' : 'scale(1)'
          }} />
          <span style={{ flex: 1 }}>
            {item}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default UnorderedListRenderer;